/**
 * Parses the error thrown by baseApiRequest which serialises the server
 * error body as:  "Server error: {"code":"...","message":"..."}"
 *
 * Returns the human-readable message string, or null if it cannot be parsed.
 */
export function parseApiError(error: unknown): string | null {
  try {
    if (!(error instanceof Error)) return null;

    const prefix = 'Server error: ';
    const msg = error.message;

    if (msg.startsWith(prefix)) {
      const json = JSON.parse(msg.slice(prefix.length));
      if (json?.message) return json.message as string;
      if (json?.code) return json.code as string;
    }

    // Fallback – return the raw message if it's useful
    return msg || null;
  } catch {
    return null;
  }
}
